export default __webpack_public_path__ + "static/media/portfolio-icon.a3bfcf5e.svg";